import { styled as e } from "styled-components";
import { Icon as o } from "../Icon/index.js";
import { Colors as r } from "../../styles/colors/index.js";
import { CaptionHeavy as i } from "../../styles/typography/index.js";
import { MediaQuery as a } from "../../styles/variables.js";
import { Theme as t } from "../../styles/themes/index.js";
const g = e.div`
  -webkit-tap-highlight-color: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-radius: 24px;
  cursor: pointer;
  width: 100%;
  min-width: 320px;
  height: 46px;
  background-color: rgba(${r.White}, 0.1);
  border: 2px solid rgb(${r.Silver});

  &[aria-selected='true'] {
    background-color: rgb(${r.Sand});

    &[data-is-light='true'] {
      border: 1px solid rgb(${t.colors.Brand});
    }
  }

  @media ${a.SCREEN_MD_UP} {
    min-width: unset;
    width: 230px;
    height: 44px;
  }
`, h = e.p`
  ${i}
  color: rgb(${r.White});

  &[data-is-light='true'] {
    color: rgb(${r.Graphite});
  }

  &[aria-selected='true'] {
    color: rgb(${r.Graphite});
  }
`, b = e(o)`
  color: rgb(${r.White});
  font-size: 24px;
  margin-right: 4px;

  &[data-is-light='true'] {
    color: rgb(${t.colors.Brand});
  }

  &[aria-selected='true'] {
    color: rgb(${r.Graphite});

    &[data-is-light='true'] {
      color: rgb(${t.colors.Brand});
    }
  }
`, m = e.div`
  display: flex;
  align-items: center;
`, u = e(o)`
  &&& {
    display: none;
    font-size: 24px;
    color: rgb(${r.Green});

    &[data-is-light='true'] {
      color: rgb(${t.colors.Brand});
    }

    &[aria-selected='true'] {
      display: flex;
    }
  }
`;
export {
  b as CategoryIcon,
  g as Container,
  u as IconSelect,
  h as Text,
  m as WrapperLeft
};
